/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_TradeOrder_ReverseTradeOrderByIdDto } from '../models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_ReverseTradeOrderByIdDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../../wealthlane-award-services/models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';


export class TradeOrderReversalService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppTradeOrderReversalReverseOrderById(
        requestBody?: Wealthlane_AwardSettlementService_Dtos_TradeOrder_ReverseTradeOrderByIdDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/trade-order-reversal/reverse-order-by-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
